import ContactForm from "../components/ContactForm"

function Contact() {
    return(
        <div className='page contact'>
            CONTACT

            <ContactForm />
        </div>
    )
}

export default Contact